import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';

import { Injector } from '@angular/core';

import { CountryDependencyEntityStore } from './country-dependency-entity-store';

export interface ICoaches {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  Age: number;
  Gender: string;
  Nationality: string;
  NOC: INocCoaches;
}

export interface INocCoaches {
  INA: INA[];
}

export interface INA {
  FunCode: string;
  FunName: string;
  FunYears: number[];
}


export class CoachesStore extends EntitiesStore<ICoaches> {
  constructor(http: HttpClient, injector: Injector) {
    super('COACHES', http, [{ entity: new CountryDependencyEntityStore(http, injector) }]);
  }
}
